import { IS_APPLIED_VOUCHER } from '@vfit/consumer/data-access';

const isNotFirstTime = () => localStorage.getItem(IS_APPLIED_VOUCHER);

const setIsNotFirstTime = () => localStorage.setItem(IS_APPLIED_VOUCHER, '1');

export { isNotFirstTime, setIsNotFirstTime };
